/**
 * Thai baht.
 */
export var THB = {
  code: 'THB',
  base: 10,
  exponent: 2
};